<div class="page-title backgroundImage"></div>
<div class="spacing"></div>

<section>
  <div class="widget-tabs page-dashboard-wallet">
    <div class="tf-container">
      <div class="row">
        <div class="col-12">
          <ul class="widget-menu-tab mb-40 overflow-x-auto">
            <li id="selectNumber" class="item-title" [class.active]="isTabActive('selectNumbers')">
              <a>Select your numbers</a>
            </li>
            <li id="voteNumber" class="item-title" [class.active]="isTabActive('voteTicket')">
              <a>Vote another ticket</a>
            </li>
            <li id="checkout" class="item-title" [class.active]="isTabActive('checkout')">
              <a>Confirm your purchase</a>
            </li>
          </ul>
        </div>
      </div>

      <div>
        <app-select-ticket *ngIf="currentStep === 'selectNumbers'" (next)="onSelectNumbersNext($event)">
        </app-select-ticket>

        <app-vote-ticket *ngIf="currentStep === 'voteTicket'" (next)="onVoteTicketNext($event)">
        </app-vote-ticket>

        <app-checkout *ngIf="currentStep === 'checkout'" [selectedNumbers]="selectedNumbers"
          [votedTicketNumbers]="votedTicketNumbers" (confirm)="onCheckoutConfirm($event)">
        </app-checkout>
      </div>
    </div>
  </div>
</section>
